import styled from '@emotion/styled'
//import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import List from '@mui/material/List'
//import Modal from '@mui/material/Modal'
import Link from 'next/link'
import { ReactChild, ReactFragment, ReactPortal } from 'react'
import SanityImage from '../components/SanityImage'
import sanity from '../lib/sanity'
import { MenuItem } from './Box'
import { Text18 } from './Text'
const MenuStyle = styled.div`
  background-color: #fff;
  width: 240px;
  height: 100vh;
  border-right: 1px solid #707070;
`
const Layout = (
  page: ReactChild | ReactFragment | ReactPortal,
  { logo }: LayoutProps,
) => {
  return (
    <div style={{ display: 'flex' }}>
      <MenuStyle>
        <List>
          <SanityImage src={logo} width={260} height={150} />
          <Link href="/" passHref>
            <MenuItem className="menu-item">
              <Text18>Dashboard</Text18>
            </MenuItem>
          </Link>
          <Link href="/configuration" passHref>
            <MenuItem className="menu-item">
              <Text18>Configuration</Text18>
            </MenuItem>
          </Link>
        </List>
      </MenuStyle>

      <Container sx={{ mt: 2, mb: 2 }}>{page}</Container>
    </div>
  )
}

export interface LayoutProps {
  logo: string
}

export const getStaticProps = async (): Promise<{ props: LayoutProps }> => ({
  props: await sanity.fetch(
    `*[_type == 'settings' && _id == 'settings'][0] {
        "logo": example_image.asset._ref
      }`,
  ),
})

export default Layout
